import { render, staticRenderFns } from "./rekonpbbkr.vue?vue&type=template&id=216fc525&scoped=true"
import script from "./rekonpbbkr.vue?vue&type=script&lang=js"
export * from "./rekonpbbkr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216fc525",
  null
  
)

export default component.exports